import moment from 'moment-jalaali';

/**
 * توابع کمکی برای تبدیل زمان
 */

// تبدیل زمان به دقیقه
export const timeToMinutes = (time) => {
  if (!time || typeof time !== 'string') return 0;
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

// تبدیل دقیقه به زمان
export const minutesToTime = (minutes) => {
  if (!minutes || typeof minutes !== 'number') return '00:00';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

// تولید ساعات پیشنهادی بر اساس ساعات کاری و استراحت
export const generateTimeSlots = (workingHours, sessionDuration) => {
  if (!workingHours || !sessionDuration) return [];

  const slots = [];
  const startTime = workingHours.startTime;
  const endTime = workingHours.endTime;
  const breakStart = workingHours.breakStart;
  const breakEnd = workingHours.breakEnd;

  // تبدیل زمان‌ها به دقیقه
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);
  const breakStartMinutes = breakStart ? timeToMinutes(breakStart) : null;
  const breakEndMinutes = breakEnd ? timeToMinutes(breakEnd) : null;

  // تولید ساعات از شروع تا پایان
  for (let time = startMinutes; time + sessionDuration <= endMinutes; time += sessionDuration) {
    // بررسی اینکه آیا در زمان استراحت قرار دارد
    if (breakStartMinutes && breakEndMinutes) {
      if (time >= breakStartMinutes && time < breakEndMinutes) {
        continue; // این ساعت در زمان استراحت است
      }
      
      // اگر زمان بعد از استراحت است، از breakEnd شروع کن
      if (time < breakEndMinutes && time + sessionDuration > breakStartMinutes) {
        time = breakEndMinutes - 1; // یک دقیقه قبل از پایان استراحت
        continue;
      }
    }
    
    slots.push(minutesToTime(time));
  }

  return slots;
};

// تبدیل تاریخ شمسی به میلادی با تنظیم timezone
export const jalaliToGregorian = (jalaliDate) => {
  if (!jalaliDate) return null;
  
 
  
  try {
    // استفاده از moment-jalaali برای تبدیل دقیق
    const gregorianMoment = moment(jalaliDate, 'jYYYY/jMM/jDD');
    
    
    if (gregorianMoment.isValid()) {
      // تنظیم زمان به نیمه شب برای جلوگیری از مشکلات timezone
      // استفاده از 12:00 به جای 00:00 برای جلوگیری از تغییر روز هفته
      gregorianMoment.hour(12).minute(0).second(0).millisecond(0);
      
      // استفاده از ISO string برای جلوگیری از مشکلات timezone
      const isoDate = gregorianMoment.format('YYYY-MM-DD');
      
      // ایجاد Date جدید از ISO string
      const result = new Date(isoDate);
    
      
      return result;
    }
  } catch (error) {
    console.error('Error converting Jalali to Gregorian:', error);
    return null;
  }
  return null;
};
